<template lang="html">
  <ol class="mpv-breadcrumb col-8 col-md-10 px-0 text-left">
    <!-- mobile -->
    <li class="breadcrumb-item button d-flex d-sm-none my-auto">
      <div class="breadcrumb-item-mobile-back" @click="$emit('close')">
        <a href="#" @click.prevent="$router.go(-1)" class="px-3">
          <font-awesome-icon :icon="[ 'fas', 'arrow-left' ]" />
          <span class="mx-2">volver</span>
          <span class="mr-0">|</span>
        </a>
      </div>
    </li>
    <!-- desktop -->
    <li class="breadcrumb-item d-none d-sm-inline-block">
      <a
        class="text-secondary"
        @click.prevent="$router.go(-1)"
        href="#">
        <font-awesome-icon class="mr-2 small text-primary" :icon="['fa', 'chevron-left']" />
        Volver
      </a>
    </li>
    <template v-for="(bc, index) in items" >
      <li :key="index" :class="[
      'breadcrumb-item',
      `${index === 0 ? 'first' : ''}`,
      `${index === (items.length - 1) ? 'last' : ''}`
      ]">
        <router-link
          v-if="!noLinks && index === (items.length - 1)"
          class="text-secondary"
          :to="{ path: bc.path, query: $route.query }">
          <h1 class="h1-title-bc">{{ bc.name }}</h1>
        </router-link>
        <router-link
          v-else-if="!noLinks"
          class="text-secondary"
          :to="{ path: bc.path, query: bc.query ? bc.query : $route.query }">
          {{ bc.name }}
        </router-link>
        <a v-else>
          {{ bc.name }}
        </a>
      </li>
    </template>
  </ol>
</template>

<script>
export default {
  props: {
    items: Array, // {path, name}
    filters: Object | null,
    noLinks: Boolean
  }
}
</script>

<style lang="scss">
  @import '/../../scss/aspect';
  @import '/../../scss/colors';
  @import '/../../scss/breakpoints';

  .h1-title-bc {
    margin: 0;
    font-size: .8rem;
    font-weight: 700;
    @media screen and (max-width: map-get($grid-breakpoints, "sm")) {
      font-size: .9rem;
    }
  }

  .mpv-breadcrumb {
    & li {
      display: inline-block;
    }

    & .breadcrumb-item + .breadcrumb-item::before {
      content: ">" !important;
    }

    & .breadcrumb-item + .breadcrumb-item:nth-child(2)::before {
      content: '' !important;
    }

    & .breadcrumb-item.first::before {
      content: "|" !important;
    }

    & .breadcrumb-item:last-child a {
      color: $primary !important;
      margin: 0;
      padding: 0;
      display: inline-block;
    }
  }

  @media screen and (max-width: map-get($grid-breakpoints, "sm")) {
    .mpv-breadcrumb {
      display: flex;
      /*max-width: 78%;*/
      margin: auto 0;
      & .breadcrumb-item {
        &-mobile-back {
          font-size: 1rem;
        }
      }
      & .breadcrumb-item a {
        color: white !important;
        font-size: 0.9rem !important;
      }

      & .breadcrumb-item + .breadcrumb-item::before {
        display: none;
      }

      & .breadcrumb-item:last-child a {
        color: $white !important;
      }

      & .breadcrumb-item {
        display: none;
        padding: 0;

        &.last {
          display: flex !important;
          margin: auto 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Breadcrumb.vue